/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ToggleProStoreDeveloperAccessMutationVariables = Types.Exact<{
  organizationId: Types.Scalars['ID'];
  enabled: Types.Scalars['Boolean'];
}>;


export type ToggleProStoreDeveloperAccessMutation = { __typename: 'Mutation', serviceAdminToggleProStoreDeveloperAccess: boolean };


export const ToggleProStoreDeveloperAccessDocument = gql`
    mutation ToggleProStoreDeveloperAccess($organizationId: ID!, $enabled: Boolean!) {
  serviceAdminToggleProStoreDeveloperAccess(
    organizationId: $organizationId
    enabled: $enabled
  )
}
    `;
export type ToggleProStoreDeveloperAccessMutationFn = ApolloReactCommon.MutationFunction<ToggleProStoreDeveloperAccessMutation, ToggleProStoreDeveloperAccessMutationVariables>;

/**
 * __useToggleProStoreDeveloperAccessMutation__
 *
 * To run a mutation, you first call `useToggleProStoreDeveloperAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProStoreDeveloperAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProStoreDeveloperAccessMutation, { data, loading, error }] = useToggleProStoreDeveloperAccessMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleProStoreDeveloperAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleProStoreDeveloperAccessMutation, ToggleProStoreDeveloperAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleProStoreDeveloperAccessMutation, ToggleProStoreDeveloperAccessMutationVariables>(ToggleProStoreDeveloperAccessDocument, options);
      }
export type ToggleProStoreDeveloperAccessMutationHookResult = ReturnType<typeof useToggleProStoreDeveloperAccessMutation>;
export type ToggleProStoreDeveloperAccessMutationResult = ApolloReactCommon.MutationResult<ToggleProStoreDeveloperAccessMutation>;
export type ToggleProStoreDeveloperAccessMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleProStoreDeveloperAccessMutation, ToggleProStoreDeveloperAccessMutationVariables>;